module.exports = __webpack_public_path__ + "img/MoonSword 2.fd88ce62.png";